export { default as CategoriesPage } from "./View";